import { Button as CommonButton } from "common/pixi/button";
import { cancel, delayAnimation } from "common/promises";
export class Button extends CommonButton {
    constructor(pixiContext, sheets) {
        // To remove compile error, set as any;
        let textures = [];
        for (const sheet of sheets) {
            if (sheet.hasAnimation(fileName)) {
                textures = sheet.animationTextures(fileName);
            }
        }
        const hitArea = { x: 245, y: 992, w: 230, h: 100 };
        super({
            pixiContext,
            textures,
            hitArea,
            hideButtonWhenclick: false,
        });
    }
    animate() {
        return cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await delayAnimation(100);
                canceler.check();
                this.sprite.texture = this.config.textures[0];
                await delayAnimation(100);
                canceler.check();
                this.sprite.texture = this.config.textures[1];
            }
        });
    }
}
export const fileName = "button";
//# sourceMappingURL=button.js.map